import React from 'react';
import './styling.css';

function SubheaderComponent({ question, children }) {
  return (
    <div className="subheader-component">
      <div>
        {question.Text}
        {question['Required?'] &&
          String(question['Required?']).toLowerCase() === 'yes' && (
            <span style={{ color: '#d32f2f', marginLeft: 4 }}>*</span>
          )}
      </div>
      {children}
    </div>
  );
}

export default SubheaderComponent;
